var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteCursorIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46594 21.6456L12.5105 17.5263C12.872 17.0372 13.5826 16.9813 14.0161 17.4078L21.0303 24.3098C21.4195 24.6928 22.0439 24.6928 22.4331 24.3098L25.2483 21.5397C25.6568 21.1377 25.6446 20.4753 25.2215 20.0886L18.4137 13.8683C17.932 13.4281 17.9941 12.6519 18.5397 12.2939L22.9918 9.37335C23.7013 8.90793 23.5452 7.826 22.7331 7.58012L2.84197 1.55769C2.06693 1.32303 1.34896 2.05874 1.60244 2.82782L7.71201 21.3642C7.966 22.1349 8.98367 22.2981 9.46594 21.6456Z",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteCursorIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/white_cursor_icon.e63e54e15e0a35e06d468bac2a3343d1.svg";